export enum SEO_PERMISSIONS {
  SEO_VIEW = 'SEO_VIEW',
  SEO_WRITE = 'SEO_WRITE',
  SEO_KEYWORD_VIEW = 'SEO_KEYWORD_VIEW',
  SEO_KEYWORD_WRITE = 'SEO_KEYWORD_WRITE',
}
